import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {HttpRequestBuilder} from "../../../../shared/utils";
import {UrlProviderService} from "../../../../shared/services/general";
import {map, retry} from "rxjs/operators";
import {Observable} from "rxjs";
import {ResultAnalysis} from "../models/result-analysis";

@Injectable({
  providedIn: 'root'
})
export class ResultAnalyzerClientService {

  constructor(private http: HttpClient, private urlProvider: UrlProviderService) {
  }

  getAnalysis(orderCode: string): Observable<HttpResponse<ResultAnalysis[]>> {
    const builder = new HttpRequestBuilder(this.http)
      .setUrl(`${this.urlProvider.AiAnalyzerUrl}/orders/${orderCode}/result-analysis`)
      .setMethod('GET');

    builder.getOptions().reportProgress = true;
    return builder.build().pipe(retry(2), map(x => x as HttpResponse<ResultAnalysis[]>));
  }

  checkIfOrderHasBeenAnalyzed(orderCode: string): Observable<HttpResponse<boolean>> {
    const builder = new HttpRequestBuilder(this.http)
      .setUrl(`${this.urlProvider.AiAnalyzerUrl}/orders/${orderCode}/result-analysis-exists`)
      .setMethod('GET')
      .setHeader('Accept', 'application/json')
      .setHeader('Content-Type', 'application/json');

    builder.getOptions().reportProgress = true;
    return builder.build().pipe(retry(2), map(x => x as HttpResponse<boolean>));
  }

  checkIfClientIsEnabled(clientCode: string): Observable<HttpResponse<boolean>> {
    const builder = new HttpRequestBuilder(this.http)
      .setUrl(`${this.urlProvider.AiAnalyzerUrl}/exists-client-code/${clientCode}`)
      .setMethod('GET')
      .setHeader('Accept', 'application/json')
      .setHeader('Content-Type', 'application/json');

    builder.getOptions().reportProgress = true;
    return builder.build().pipe(retry(2), map(x => x as HttpResponse<boolean>));
  }
}
